import React from "react";
// import { Link } from 'react-router-dom';

class Strategy extends React.Component {
  render() {
    return (
      <section className="strategy-area">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6 col-md-5">
              <div className="image"></div>
            </div>

            <div className="col-lg-6 col-md-7">
              <div className="about-strategy ptb-80">
                <div className="section-title">
                  <h4>Soluciones Altamente Cretivas</h4>
                  <h2>
                    Nuestra <span>Estrategia</span>
                  </h2>
                  <p>
                    Los integrantes de nuestro Núcleo se encuentran altamente
                    capacitados para asesorar y acompañar los clientes de manera
                    práctica en todos los asuntos relacionados a sus áreas de
                    actuación profesionales específicas, lográndose así una
                    integración interdisciplinaria estratégica y contundente.
                  </p>
                </div>

                <ul>
                  <li>
                    <i className="fa fa-check"></i>Compromiso
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Efectividad
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Transparencia
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Colaboración
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Asistencia
                  </li>
                  <li>
                    <i className="fa fa-check"></i>Resultados
                  </li>
                </ul>

                {/* <Link to="#" className="btn btn-primary">Read More</Link> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Strategy;
